
//
//  다국어 객체 생성 관리 (2018/06/01 정재윤)
// -
//

import Lang from './lang'

if (window.vue.getInstance('lang') === undefined) {
  let i18n = Lang.createInstance()
  Lang.i18n = i18n
  window.vue.setInstance('lang', Lang)
}



// WEBPACK FOOTER //
// ./src/_fdp/core/i18n/index.js